import * as React from 'react';

import { DictionarySettingsStore } from 'stores/models/fieldsSettings';

export type DictionaryTableContextParams = {
  store: DictionarySettingsStore;
};

const DictionaryTableContext = React.createContext<
  DictionaryTableContextParams | undefined
>(undefined);

export const useDictionaryTableContext = () => {
  const ctx = React.useContext(DictionaryTableContext);

  if (!ctx) {
    throw new Error('has not DictionaryTableContext');
  }

  return ctx;
};

export const DictionaryTableProvider: React.FC<{
  children: React.ReactNode;
  store: DictionarySettingsStore;
}> = ({ children, store }) => {
  const value: DictionaryTableContextParams = { store };

  return (
    <DictionaryTableContext.Provider value={value}>
      {children}
    </DictionaryTableContext.Provider>
  );
};
